import {MatDialogConfig} from '@angular/material/dialog';

export class AppConstants {
  // localStorage key
  public static USER_LOCALE_KEY = 'userLocaleKey';
  public static CURRENT_USER_ROLE = 'currentUserRole';
  public static CURRENT_USER_ID = 'currentUserId';
  public static CURRENT_USER_TOKEN = 'currentUserToken';
  public static CURRENT_USER_TOKEN_EXPIRES_AT = 'userLocalKeyExpiresAt';
  public static CURRENT_USER_REFRESH_TOKEN_EXPIRES_AT = 'userLocalRefreshKeyExpiresAt';

  public static EU_COUNTRY_CODES: string[] = [
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR',
    'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
  ];

  // regex patterns
  public static PHONE_PATTERN = '^\\+[0-9]{7,15}$';
  public static EMAIL_PATTERN = '^[\'_a-zA-Z0-9-]+(\.[\'_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.(([a-zA-Z]+))$';
  public static NUMBER_PATTERN = '^[0-9]*$';

  public static VALIDATORS_PREFIX = 'validations.errors.';

  public static API_DATE_FORMAT = 'YYYY-MM-DD';

  public static LIST_SEARCH_DELAY = 400;
  public static LIST_PAGE_SIZE = 10;

  public static compareObjectsById(o1: any, o2: any): boolean {
    return o1 && o2 && String(o1.Id) === String(o2.Id);
  }

  public static compareObjectsByID(o1: any, o2: any): boolean {
    return o1 && o2 && String(o1.ID) === String(o2.ID);
  }

  public static matDialogConfig(): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = {top: '0'};
    dialogConfig.autoFocus = false;
    return dialogConfig;
  }

}
